import { Button, FormGroup, Label, Modal, Textarea } from "@xola/ui-kit";
import React, { useState } from "react";
import { Except } from "type-fest";

interface AttachmentInstructionModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (instruction: string) => void;
}

export const AttachmentInstructionModal = ({ isOpen, onClose, onConfirm }: AttachmentInstructionModalProps) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalContent onClose={onClose} onConfirm={onConfirm} />
        </Modal>
    );
};

const ModalContent = ({ onConfirm }: Except<AttachmentInstructionModalProps, "isOpen">) => {
    const [instruction, setInstruction] = useState("");
    const [isError, setIsError] = useState(false);
    const handleClick = () => {
        if (instruction.trim().length > 0) {
            setIsError(false);
            onConfirm(instruction);
            setInstruction("");
        } else {
            setIsError(true);
        }
    };

    return (
        <>
            <Modal.Header>Attachment Instructions</Modal.Header>
            <Modal.Body>
                <FormGroup>
                    {isError && <Label className="!text-danger">Instruction is required</Label>}
                    <Textarea
                        isRequired
                        value={instruction}
                        row={3}
                        isError={isError}
                        data-testid="attachment-instruction-modal-textarea"
                        onKeyUp={(e: any) => setIsError(!e.target.value)}
                        onChange={(e: any) => setInstruction(e.target.value)}
                    />
                </FormGroup>
            </Modal.Body>
            <Modal.Footer className="flex justify-end">
                <Button color="primary" onClick={handleClick}>
                    Save & Close
                </Button>
            </Modal.Footer>
        </>
    );
};
